import React from 'react';
import classNames from 'classnames';
import { random } from 'lodash';

const TextPlaceholder = ({ minWidth, maxWidth, large }) => (
  <div
    className={classNames('TextPlaceholder', {
      'TextPlaceholder--large': large,
    })}
    style={{
      width: `${random(minWidth, maxWidth)}%`,
    }}
  />
);

TextPlaceholder.defaultProps = {
  minWidth: 40,
  maxWidth: 80,
  large: false,
};

export default TextPlaceholder;
